export default "__VITE_PUBLIC_ASSET__5b9cec6b__"